// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__1yur5","head_form":"styles_head_form__1LhOg","main_div":"styles_main_div__BuZWP"};